import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRectangle3PointTool = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M5 7H21C23.8284 7 25.2426 7 26.1213 7.87868C27 8.75736 27 10.1716 27 13V25H11C8.17157 25 6.75736 25 5.87868 24.1213C5 23.2426 5 21.8284 5 19V7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_4231_26917)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M28 23.5C28 22.1193 26.8807 21 25.5 21C24.1193 21 23 22.1193 23 23.5C23 24.8807 24.1193 26 25.5 26C26.8807 26 28 24.8807 28 23.5Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 8.5C9 7.11929 7.88071 6 6.5 6C5.11929 6 4 7.11929 4 8.5C4 9.88071 5.11929 11 6.5 11C7.88071 11 9 9.88071 9 8.5Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 8.5C28 7.11929 26.8807 6 25.5 6C24.1193 6 23 7.11929 23 8.5C23 9.88071 24.1193 11 25.5 11C26.8807 11 28 9.88071 28 8.5Z",
					fill: "currentColor"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_4231_26917",
			x: 1,
			y: 4,
			width: 30,
			height: 26,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_4231_26917"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_4231_26917",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgRectangle3PointTool);
export { ForwardRef as ReactComponent };
